import { LegalAgreement } from '../legal/contract';

export class Guardian {
  public name: string;
  public contactNumber: string;
  public email: string;
  public address: string;
  public lastname: string;
  public legalAgreements: LegalAgreement[];
}
